<template>
    <div id="navbar-container" v-if="isAuthenticated">
        <div id="test">
            <router-link to="/site-settings/exhibition-edit" style="text-decoration: none;">
                <div>
                    <h3 class="main-link">Sergi Sayfası</h3>
                </div>
            </router-link>
            
            <router-link to="/site-settings/portfolio-edit" style="text-decoration: none;">
                <div>
                    <h3 class="main-link">Portfolyo Sayfası</h3>
                </div>
            </router-link>

            <router-link to="/site-settings/biography-edit" style="text-decoration: none;">
                <div>
                    <h3 class="main-link">Biyografi Sayfası</h3>
                </div>
            </router-link>
            
            <br><br><br><br><br><br><br><br><br><br><br><br><br><br>
            <div>
                <h3 class="main-link" @click="logout">Çıkış</h3>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    data(){
        return{
            isAuthenticated: false,
        }
    },
    methods:{
        logout(){
            localStorage.removeItem("confirmation");
            localStorage.removeItem("portfolioPageRefreshed");
            localStorage.removeItem("exhibitionPageRefreshed");
            this.$router.push('/site-settings');
            window.location.reload();
        }
    },
    mounted(){
        if (localStorage.getItem("confirmation") === "onaylandi") {
            this.isAuthenticated = true;
        }else{
            this.isAuthenticated = false;
        }
    }
}
</script>

<style scoped>
#navbar-container{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: rgb(27, 27, 27);
    padding-top: 15px;
}

#test{
    display: flex;
    flex-direction: column;
    width: 240px;
}

.main-link{
    margin-left: 20px;
    color: aliceblue;
    letter-spacing: 1.5px;
    cursor: pointer;
}

.main-link:hover {
    color: rgb(27, 27, 27);
    background-color: aliceblue;
}

.sub-link {
    cursor: pointer;
}

.sub-link:hover {
    color: rgb(27, 27, 27);
    background-color: aliceblue;
}

li{
    list-style: none;
}

li:hover p{
    color: black;
    background-color: aliceblue;
}

p{
    color: aliceblue;
}


</style>